export const Alert = 'alert';
export const Event = 'event';

export const InfoSeverity = 'info';
export const WarningSeverity = 'warning';
export const CriticalSeverity = 'critical';
export const MajorSeverity = 'major';
export const MinorSeverity = 'minor';

export const DefaultAnnotationLabels = {
    info: 'Info alert',
    warning: 'Warning alert',
    minor: 'Minor alert',
    major: 'Major alert',
    critical: 'Critical alert',
    event: 'Event',
};

export const TypeFieldName = 'type';
export const SeverityFieldName = 'severity';
